import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M24.4 7.613c-0.52-0.52-1.36-0.52-1.88 0l-6.52 6.507-6.52-6.52c-0.52-0.52-1.36-0.52-1.88 0s-0.52 1.36 0 1.88l6.52 6.52-6.52 6.52c-0.52 0.52-0.52 1.36 0 1.88s1.36 0.52 1.88 0l6.52-6.52 6.52 6.52c0.52 0.52 1.36 0.52 1.88 0s0.52-1.36 0-1.88l-6.52-6.52 6.52-6.52c0.507-0.507 0.507-1.36 0-1.867z" })
});
export default SvgClose;
